import React from "react";
import BlackButton from "./BlackButton";

const SectionHeader = ({
  tagline,
  title,
  description,
  className = "",
  childClassName = "",
}) => {
  return (
    <div
      className={`flex flex-col items-center text-center px-[5%] md:px-0 ${className}`}
    >
      {tagline && (
        <BlackButton
          text={tagline}
          padding="px-3 py-1.5 md:px-4 md:py-2"
          className="mb-4"
          textClassName="text-xs md:text-lg uppercase font-theBrittanySans"
        />
      )}
      <h1 className="text-3xl md:text-4xl font-bold text-white leading-[140%] tracking-[0] mb-4">
        {title}
      </h1>

      <p
        className={`text-base leading-[140%] tracking-[0] text-white max-w-2xl mb-12 ${childClassName}`}
      >
        {description}
      </p>
    </div>
  );
};

export default SectionHeader;
